<template>
    <PageContent slug="privacy" />
</template>

<script setup>
import PageContent from './PageContent.vue'
</script>

